import { lazy } from 'react';
import DefaultView from 'components/common/DefaultView';
import Main from 'components/views/main/Main';

const Splash = lazy(() => import(/* webpackPrefetch: true */ 'components/views/Splash'));
const NotFound = lazy(() => import('components/views/NotFound'));
// [hygen] Import views

export const ROUTE_PATHS = {
  SPLASH: '/',
  DEFAULT: '/dashboard',
  NOT_FOUND: '/404',
  // [hygen] Add path routes
};

const routes = [
  {
    path: ROUTE_PATHS.SPLASH,
    element: <Splash />,
  },
  {
    path: ROUTE_PATHS.DEFAULT,
    element: (
      <DefaultView>
        <Main />
      </DefaultView>
    ),
    children: [
      // { path: '/', element: <Navigate to='/<your default view>' /> },
      // { path: ROUTE_PATHS.STATE_GEOMETRIES, element: <StateGeometries /> },
      // [hygen] Add routes
    ],
  },
  {
    path: '*',
    element: (
      <DefaultView>
        <NotFound />
      </DefaultView>
    ),
  },
];

export default routes;
